import { applyFunction } from '@intercom/pulse/lib/computed-properties';

//TODO: GJ: extract to https://github.com/intercom/embercom-computed-properties/issues/13
export default function (key) {
  return applyFunction(window.encodeURIComponent, key);
}